import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import Toast from "components/Toast"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import { useLocation } from "react-router-dom"
import Select from "react-select"
import Button from "../../../../components/Button"
import InputField from "../../../../components/InputField"
import { addNewMasterServices, getAllCategories, getCenterDetails, getConsultantServiceDetailsById, getRateCardByServiceId, getServiceDetailByServiceId, getServicesNotInCenter, getSubCategoryByCategory, updateMasterServices } from "../../../../core/services/api"
import "../../CenterAdmin/AddNewReferral/AddNewReferral.scss"
import "./CopyServices.scss"



function AddNewMasterService() {
  const history = useHistory()
  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState<any>()
  const [formErrors, setFormErrors] = useState<any>()
  const location = useLocation()
  const id = location?.state?.idValue
  const origin = location?.state?.origin
  const [doctorReferralInfo, setDoctorReferralInfo] = useState<any>()
  const [centers, updateCenters] = useState<any>()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)
  const [displayToast, toggleDisplayToast] = useState<any>(false)
  //Service Id info
  const [serviceIdInfo, setServiceIdInfo] = useState<any>({});
  const [serviceRateInfo, setServiceRateInfo] = useState<any>();
  const [editState, setEditState] = useState<any>(false);
  const [centerDetail, setCenterDetail] = useState<any>()
  // const [centerId, setCenterId] = useState<any>(userDetail?.currentCenter?.centerId);

  const [centerId, setCenterId] = useState<any>(location?.state?.centerId);
  const [centerName, setCenterName] = useState<any>(location?.state?.centerName);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);

  const taxTypeDropdown = [
    // { label: 'GST', value: 'GST' },
    { label: 'IGST', value: 'IGST' },
    { label: 'CGST', value: 'CGST' },
    { label: 'SGST', value: 'SGST' },

  ]




  const serviceId = location.state.idValue;

  useEffect(() => {

    //setRole(userDetail?.currentRole);
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error");
    })

    if (location.state.functionType === "edit") {
      //get service Id Info
      getConsultantServiceDetailsById(serviceId).then((res: any) => {
        setServiceIdInfo(res);
      }).catch((err: any) => {
        console.log(err, "error");
      })

      if (location.state.type == "Center") {
        //service Id Rate Info
        getRateCardByServiceId(location?.state?.centerId, serviceId).then((res: any) => {
          setServiceRateInfo(res);
        }).catch((err: any) => {
          console.log(err, "err");
        })
      }
    }

  }, [])



  const initialStateService =
  {
    name: "",
    appointmentType: "",
    defaultPrice: "",
    sacNumber: "",
    discountType: "",
    discountNumber: "",
    isEditable: false

  }
  // taxes add and delete
  const taxDetails = {
    name: "",
    percentage: ""
  }

  //Rate card add and Delete
  const rateCard = {
    categoryId: "",
    price: "",
    discountType: "PERCENTAGE",
    discount: 0,
    subCategory: "",
    categoryType: "",
    categoryValue: ""
  }

  const [serviceInfo, setserviceInfo] = useState<any>(initialStateService);
  let [taxDetailsInfo, setTaxDetailsInfo] = useState([taxDetails]);
  let [rateCardInfo, setRateCardInfo] = useState([rateCard]);
  const [categoryTypes, setCategoryTypes] = useState<any>();
  const [categoryDropdown, setCategoryDropdown] = useState<any>();
  const [subCategoryTypes, setsubCategoryTypes] = useState<any>([])
  // const categoryType = [
  //   "SELF_PAYING",
  //   "INSURANCE",
  //   "TRUST",
  //   "CORPORATE",
  //   "CGHS",
  //   "PSU",
  //   "INSURANCE_TPA"
  // ]
  // const categoryDropdown = categoryType?.map((values: any) => {
  //   return {
  //     label: values,
  //     value: values,
  //   }
  // })

  const subCategoryDropdown = subCategoryTypes?.map((values: any) => {
    return {
      label: values.name,
      value: values.id
    }
  })

  useEffect(() => {
    getAllCategories()
      .then((res) => {
        const temp = res?.map((values: any) => {
          return {
            label: values,
            value: values,
          }
        })
        setCategoryDropdown(temp)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }, [])

  useEffect(() => {
    if (categoryTypes) {
      getSubCategoryByCategory(categoryTypes)
        .then((res) => {
          setsubCategoryTypes(res);
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [categoryTypes])

  useEffect(() => {


    if (location.state.functionType === "edit") {
      if (location.state.type === "Master") {
        console.log(serviceIdInfo, "service iD info masterrr");
        const editStateService = {
          name: serviceIdInfo.name,
          appointmentType: serviceIdInfo?.appointmentType,
          defaultPrice: serviceIdInfo?.masterDefaultPrice,
          salesHead: serviceIdInfo?.salesHead,
          sacNumber: "",
          discountType: "",
          discountNumber: "",
          isEditable: serviceIdInfo?.isEditable

        }
        console.log(editStateService, "edit State Service");
        setserviceInfo(editStateService);
      }
      if (location.state.type == "Center") {

        let centerDefaultPrice: any;
        let centerTax: any;
        let centerSAC: any;
        const centerServiceId = serviceIdInfo?.centerDefaultPrices?.filter((item: any) => {

          if (item?.centerId === location?.state?.centerId) {
            centerDefaultPrice = item.defaultPrice;
            centerTax = item.tax;
            centerSAC = item.sacNumber;
          }
        })


        const editStateService = {
          name: serviceIdInfo.name,
          appointmentType: serviceIdInfo.appointmentType,
          defaultPrice: centerDefaultPrice,
          salesHead: serviceIdInfo.salesHead,
          sacNumber: centerSAC,
          discountType: "",
          discountNumber: "",
        }
        setserviceInfo(editStateService);
        setTaxDetailsInfo(centerTax);
        setRateCardInfo(serviceRateInfo);

      }
    }


  }, [serviceIdInfo, serviceRateInfo])


  const handleSubmit = (e: any) => {
    e.preventDefault()
    setFormErrors(validate(doctorReferralInfo))
    setIsSubmit(true)
  }


  const validate = (values: any) => {
    const errors: any = {}
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!values.name) {
      errors["name"] = "Name is required"
    }
    if (values.email && !regex.test(values.email)) {
      errors["email"] = "This is not a valid email format!"
    }
    return errors
  }

  //For Removing Incremental Field
  function isValidNumber(str: any) {
    return !isNaN(str);
  }



  function onSubmit(e: any) {
    // setIsLoading(true)
    e.preventDefault()
    rateCardInfo?.map((item: any) => {
      delete item["subCategory"]
      delete item["categoryType"]
      delete item["categoryValue"]
    })

    const data = {
      centerId: location?.state?.type === "Master" ? null : centerId,
      name: serviceInfo.name,
      sacNumber: serviceInfo.sacNumber,
      appointmentType: serviceInfo.appointmentType,
      defaultPrice: serviceInfo.defaultPrice,
      salesHead: serviceInfo.salesHead,
      tax: location?.state?.type === "Master" ? [] : taxDetailsInfo,
      taxApplicable: true,
      rates: location?.state?.type === "Master" ? [] : rateCardInfo,
      isEditable: serviceInfo.isEditable
    }


    if (location.state.functionType == "add") {
      if (taxDetailsInfo.every(tax => tax.name === "" && (tax.percentage === null || tax.percentage === ""))) {
        data.tax = [];
      }

      if (rateCardInfo?.every(rate => rate.price === "" && rate.categoryId == "" && rate.discount == 0)) {
        data.rates = [];
      }

      addNewMasterServices(data)
        .then((data) => {
          setResData(data)
          setIsLoading(false)
          toggleDisplayToast({ text: "Service has been saved successfully", type: "success" })

        })
        .catch((err: any) => {
          setIsLoading(false)
          toggleDisplayToast({ text: "Unable to save the service", type: "error" })
        })

    }
    if (location.state.functionType == "edit") {
      if (taxDetailsInfo.every(tax => tax.name === "" && (tax.percentage === null || tax.percentage === ""))) {
        data.tax = [];
      }

      if (rateCardInfo?.every(rate => rate.price === "" && rate.categoryId == "" && rate.discount == 0)) {
        data.rates = [];
      }

      rateCardInfo?.map((item: any) => {
        delete item["id"]
        delete item["centerId"]
        delete item["serviceId"]

      })


      data["centerId"] = location?.state?.centerId
      updateMasterServices(serviceId, data).then((data) => {
        setResData(data)
        setIsLoading(false)
        toggleDisplayToast({ text: "Service has been updated successfully", type: "success" })

      })
        .catch((err: any) => {
          setIsLoading(false)
          toggleDisplayToast({ text: "Unable to update the service", type: "error" })
        })
    }
  }



  const appointment = {
    appointmentType: [
      "OPD",
      "IPD",
      "HC",
    ],
    discountType: [
      'PERCENTAGE',
      'AMOUNT'
    ]
  }
  const appointments: any = appointment?.appointmentType.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const discountsDropdown: any = appointment.discountType?.map((ele: any) => {
    return { label: ele, value: ele }
  })


  //Adding the services dropdown for medicines that are not in center
  const [servicesNotInCenter, setServicesNotInCenter] = useState<any>();
  console.log(location, "location");
  useEffect(() => {
    console.log("services not in center");
    console.log(centerId, "center Id");
    if (centerId) {
      getServicesNotInCenter(centerId).then((res: any) => {
        console.log(res, "services not in center andar wala");
        const servicesDropdown: any = res?.map((ele: any) => {
          return { label: ele?.name, value: ele?.id }
        })
        setServicesNotInCenter(servicesDropdown);
      }).catch((err: any) => {
        console.log(err);
      })
    }

  }, [centerId])


  return (
    <div className="add-new-referral-container">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            // history.push('/Service')
            if (location?.state?.type === "Master") {
              history.push({
                pathname: "/Service",
                state: { type: 'Master', value: 0, previousCenterId: centerId, previousCenterName: centerName },
              })
            }
            else {
              console.log(centerId, "centerId while coming back")
              history.push({
                pathname: "/Service",
                state: { type: 'Center', value: 1, previousCenterId: centerId, previousCenterName: centerName },
              })
            }
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>



        {location.state.functionType === 'add' ? <> <div className="add-new-text">Add New Services</div></>
          : <><div className="add-new-text">Edit Services</div></>}


      </div>
      <div className="add-new-referral-details">
        <form onSubmit={(e: any) => onSubmit(e)}>
          {location.state.type === "Center" ? <>
            <div className="row nameDetails">
              <div className="col-3">
                <label className="textlabel">Center Name:</label>
              </div>
              <div className="col-3">

                {userRole === "CENTER_ADMIN" ? <>
                  {userDetail?.currentCenter?.centerName}
                </> : <>
                  {location.state.functionType === "edit" ? <>
                    {centerName}
                  </> : <>
                    <div className="custom-react-select">
                      <Select
                        className=""
                        name="center"
                        defaultValue={{
                          label: "",
                          value: ""
                        }}
                        value={{
                          label: centerName,
                          value: centerId
                        }}
                        isDisabled={readOnly}
                        options={dropdownCenters}
                        styles={customSelectStyles()}
                        onChange={(evnt: any) => {
                          setCenterId(evnt?.value);
                          setCenterName(evnt?.label);
                          //setData({ ...data, securityDepositMode: evnt?.value })
                        }}
                      />
                    </div>
                  </>}

                </>}

              </div>
            </div>
          </> : <></>}

          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Service Name:</label>
            </div>
            <div className="col-3">
              {location.state.type === "Center" ? <>
                {location.state.functionType === "edit" ? <>
                  {serviceInfo.name}
                </> : <>
                  <div className="custom-react-select">
                    <Select
                      className="service-name"
                      options={servicesNotInCenter}
                      styles={customSelectStyles()}
                      onChange={(option: any) => {
                        setserviceInfo({
                          ...serviceInfo,
                          name: option?.label,
                        })
                        getServiceDetailByServiceId(option?.value).then((res: any) => {
                          setserviceInfo({
                            ...serviceInfo,
                            name: res?.name,
                            defaultPrice: res?.masterDefaultPrice,
                            salesHead: res?.salesHead,
                            appointmentType: res?.appointmentType,

                          })
                        }).catch((err: any) => {
                          console.log(err, "err");
                        })

                      }}
                      placeholder=""
                      isDisabled={readOnly}
                    />
                  </div>
                </>}

              </> : <>
                <InputField
                  placeholder="Service Name"
                  readOnly={readOnly}
                  value={serviceInfo.name}
                  handleChange={(e) =>
                    setserviceInfo({
                      ...serviceInfo,
                      name: e.target.value,
                    })
                  }
                />
              </>}

            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Appointment Type:</label>
            </div>
            <div className="col-3">
              <div className="custom-react-select">

                <Select
                  className="country-select"
                  options={appointments}
                  isDisabled={readOnly}
                  styles={customSelectStyles()}
                  defaultValue={appointments}
                  onChange={(option: any) => {
                    setserviceInfo({ ...serviceInfo, appointmentType: option?.value })
                  }}
                  placeholder="Type"
                  value={appointments.filter(
                    ({ label }: any) => label === serviceInfo.appointmentType
                  )}
                />
              </div>
            </div>
          </div>
          <div className="row nameDetails">

            <div className="col-3">
              <label className="textlabel">Default Price:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Default Price"
                readOnly={readOnly}
                value={serviceInfo.defaultPrice}
                handleChange={(e) =>
                  setserviceInfo({
                    ...serviceInfo,
                    defaultPrice: e.target.value,
                  })
                }
              />
            </div>
          </div>
          {location.state.type === "Master" ?
            <>
              <div className="row nameDetails">
                <div className="col-3">
                  <label className="textlabel">Sales Head:</label>
                </div>
                <div className="col-3">
                  <InputField
                    placeholder="Sales Head"
                    readOnly={readOnly}
                    value={serviceInfo.salesHead}
                    handleChange={(e) =>
                      setserviceInfo({
                        ...serviceInfo,
                        salesHead: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </> : location.state.type === "Center" ?
              <>
                <div className="row nameDetails">
                  <div className="col-3">
                    <label className="textlabel">Sales Head:</label>
                  </div>
                  <div className="col-3">
                    <InputField
                      placeholder="Sales Head"
                      readOnly={true}
                      value={serviceInfo.salesHead}
                    />
                  </div>
                </div>
              </> : <></>
          }

          {location.state.type === "Master" ? <>
            <div className="row nameDetails">
              <div className="col-3">
                <label className="textlabel">Is Editable:</label>
              </div>
              <div className="col-3">
                <input type="checkbox" name="isEditable"
                  checked={serviceInfo?.isEditable}
                  onChange={(e) => {
                    console.log(e.target.checked, "is Editable");
                    setserviceInfo({
                      ...serviceInfo,
                      isEditable: e.target.checked,
                    })
                  }
                  }
                ></input>
              </div>
            </div>
          </> : <></>}

          {location.state.type === "Center" ? <>
            <div className="row nameDetails">

              <div className="col-3">
                <label className="textlabel">SAC Number:</label>
              </div>
              <div className="col-3">
                <InputField
                  placeholder="SAC number"
                  readOnly={readOnly}
                  value={serviceInfo.sacNumber}
                  handleChange={(e) =>
                    setserviceInfo({
                      ...serviceInfo,
                      sacNumber: e.target.value,
                    })
                  }
                />
              </div>
            </div>



            <hr />
            <label className="textlabel" style={{ paddingLeft: '30px' }}>Rate Card</label>
            {rateCardInfo?.map((e, index) => {
              return (
                <div className="bed-details-container">
                  <div className="row nameDetails">
                    <div className="col-1">
                      <label className="textlabel">Type:</label>
                    </div>
                    <div className="col-2">
                      <div className="custom-react-select">
                        <Select
                          className="select-payment"
                          defaultValue={{
                            label: "",
                            value: ""
                          }}
                          value={{
                            label: rateCardInfo[index].categoryType,
                            value: rateCardInfo[index].categoryType,
                          }}
                          styles={customSelectStyles()}
                          isDisabled={readOnly}
                          options={categoryDropdown}
                          onChange={(evnt: any) => {
                            setCategoryTypes(evnt?.value);
                            const values = [...rateCardInfo];
                            values[index].categoryType = evnt?.label;
                            values[index].subCategory = ''; // Reset subtype to empty value
                            values[index].categoryId = ''; // Reset subtype category ID to empty value
                            setRateCardInfo([...values]);
                          }}

                        />

                      </div>
                    </div>

                    <div className="col-1">
                      <label className="textlabel">SubTypes:</label>
                    </div>
                    <div className="col-2">
                      <div className="custom-react-select">
                        <Select
                          className="select-payment"
                          // defaultValue={{
                          //   label: "",
                          //   value: ""
                          // }}
                          styles={customSelectStyles()}
                          value={{
                            label: rateCardInfo[index].subCategory,
                            value: rateCardInfo[index].categoryId
                          }}
                          isDisabled={readOnly || rateCardInfo[index].categoryType === ''}
                          options={subCategoryDropdown}
                          onChange={(e: any) => {
                            const values = [...rateCardInfo];
                            values[index].subCategory = e?.label;
                            values[index].categoryId = e?.value;
                            setRateCardInfo([...values]);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row nameDetails">
                    <div className="col-1">
                      <label className="textlabel">Price:</label>
                    </div>
                    <div className="col-2">
                      <InputField
                        placeholder="Price"
                        readOnly={readOnly}
                        value={rateCardInfo[index].price}
                        handleChange={(e) => {
                          const values = [...rateCardInfo]
                          values[index].price = e.target.value
                          setRateCardInfo([...values])
                        }}
                      />
                    </div>
                    <div className="col-1">
                      <label className="textlabel"
                      >Discount Number:</label>
                    </div>
                    <div className="col-2">
                      <input
                        className="form-control"
                        type="text"
                        readOnly={readOnly}
                        value={rateCardInfo[index].discount}
                        onChange={(e) => {
                          const inputValue = parseFloat(e.target.value);
                          const values = [...rateCardInfo]
                          if (isValidNumber(inputValue)) {
                            values[index].discount = parseFloat(e.target.value);
                          } else {
                            values[index].discount = 0;
                          }
                          setRateCardInfo([...values]);
                        }}
                      />
                    </div>

                    <div className="col-1">
                      <label className="textlabel"
                      >Discount Type:</label>
                    </div>
                    <div className="col-2">
                      <div className="custom-react-select">
                        <Select
                          className="select-payment"
                          isDisabled={readOnly}
                          defaultValue={{
                            label: "",
                            value: ""
                          }}
                          styles={customSelectStyles()}
                          value={{
                            label: rateCardInfo[index].discountType,
                            value: rateCardInfo[index].discountType
                          }}
                          options={discountsDropdown}
                          onChange={(evnt: any) => {

                            const values = [...rateCardInfo]
                            values[index].discountType = evnt.value
                            setRateCardInfo([...values])
                          }}
                        />
                      </div>

                    </div>
                    <div className="col-1">
                      {readOnly == true ? <></> : <>
                        <div
                          className="delete-icon"
                          onClick={() => {
                            if (rateCardInfo.length > 0) {
                              const values = [...rateCardInfo]
                              values.splice(index, 1)
                              setRateCardInfo(values)
                            }
                          }}
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>
                      </>}
                    </div>
                  </div>
                </div>

              )
            })}
            <div className="add-new-bed-container">
              {readOnly ? <></> : <>
                <div
                  style={{}}
                  className="add-new-button"
                  onClick={() => setRateCardInfo([...rateCardInfo, rateCard])}
                >
                  Add New Rates
                </div>
              </>}
            </div>
            <hr />

            {taxDetailsInfo?.map((e, index) => {
              return (
                <div className="bed-details-container">
                  <div className="row nameDetails">
                    <div className="col-1">
                      <label className="textlabel">Tax Name:</label>
                    </div>
                    <div className="col-2">
                      {/* <InputField
                        placeholder="Tax Name"
                        value={taxDetailsInfo[index].name}
                        handleChange={(e) => {
                          const values = [...taxDetailsInfo]
                          values[index].name = e.target.value
                          setTaxDetailsInfo([...values])
                        }}
                      /> */}
                      <div className="custom-react-select">
                        <Select
                          className=""
                          styles={customSelectStyles()}
                          name="center"
                          defaultValue={{
                            label: "",
                            value: ""
                          }}
                          value={{
                            label: taxDetailsInfo[index].name,
                            value: taxDetailsInfo[index].name
                          }}
                          isDisabled={readOnly}
                          options={taxTypeDropdown}
                          onChange={(evnt: any) => {

                            const values = [...taxDetailsInfo]
                            values[index].name = evnt?.value
                            setTaxDetailsInfo([...values])
                          }}
                        />
                      </div>
                    </div>
                    {/* <div className="col-1"></div> */}
                    <div className="col-2">
                      <label className="textlabel"
                      >Tax Percentage:</label>
                    </div>
                    <div className="col-2">
                      <InputField
                        placeholder="Tax Percentage"
                        readOnly={readOnly}
                        value={taxDetailsInfo[index].percentage}
                        handleChange={(e) => {
                          const values = [...taxDetailsInfo]
                          values[index].percentage = (e.target.value)
                          setTaxDetailsInfo([...values])
                        }}

                      />
                    </div>
                    {readOnly == true ? <></> : <>
                      <div className="col-1">
                        <div
                          className="delete-icon"
                          onClick={() => {
                            if (taxDetailsInfo.length > 0) {
                              const values = [...taxDetailsInfo]
                              values.splice(index, 1)
                              setTaxDetailsInfo(values)
                            }
                          }}
                        >
                          <img
                            src="../../../../assets/images/delete-icon.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </>}
                  </div>
                </div>
              )
            })}

            <div className="add-new-bed-container">
              {readOnly ? <></> : <>
                <div
                  className="add-new-button"
                  onClick={() => setTaxDetailsInfo([...taxDetailsInfo, taxDetails])}
                >
                  Add New Tax
                </div>
              </>}
            </div>

          </> : <></>}

          {location.state.functionType == "add" ? <> <div className="buttonalignment">
            <Button text="Save"
              disabled={readOnly}
              type="submit"
              id="add-new-service-save" />
          </div></> : <>
            <div className="buttonalignment">
              <Button text="Update"
                type="submit"
                disabled={readOnly}
                id="add-new-service-save" />
            </div>
          </>}

        </form>

      </div >
      {displayToast && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9998,
            }}
          >
          </div>
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => {
              toggleDisplayToast(false)
              if (displayToast?.type === "success") {
                if (location?.state?.type === "Master") {
                  history.push({
                    pathname: "/Service",
                    state: { type: 'Master', value: 0, previousCenterId: centerId, previousCenterName: centerName },
                  })
                }
                else {
                  history.push({
                    pathname: "/Service",
                    state: { type: 'Center', value: 1, previousCenterId: centerId, previousCenterName: centerName },
                  })
                }

              }
            }}
            onCloseText="Close"
            onClickText={null}
          />
        </>

      )
      }
    </div >
  )
}
export default AddNewMasterService
